import React from 'react';
import { Form } from 'react-final-form';
import validate from './validate';
import TableFilterForm from './TableFilterForm';
import { TranslationProvider } from './translationContext';

const getStartingFields = filterFields => {
  return Object.keys(filterFields)
    .filter(field => filterFields[field].showInitially)
    .reduce((initialValues, field) => {
      initialValues[field] = '';
      return initialValues;
    }, {});
};

const TableFilter = ({ filterConfiguration, onSubmit, validations, handleReset, labels, initailVal }) => {
  const startingFields = getStartingFields(filterConfiguration);
  function validateForm(values) {
    return validate(values, labels, validations);
  }

  function render({ handleSubmit, submitting, pristine, hasValidationErrors, form }) {
    return (
      <TranslationProvider labels={labels}>
        <TableFilterForm
          filterConfiguration={filterConfiguration}
          handleSubmit={handleSubmit}
          startingFields={startingFields}
          disableSubmit={submitting || pristine || hasValidationErrors}
          form={form}
          handleReset={handleReset}
        />
      </TranslationProvider>
    );
  }

  return <Form onSubmit={onSubmit} validate={validateForm} initialValues={initailVal} render={render} />;
};

export default TableFilter;
